
import SortableListDroppableZone from "./SortableListDroppableZone";
import SortableListOptionsZone from "./SortableListOptionsZone";

const SortableListDesktopInterface = () => {
  return (
    <div className="sortable-list-input row">
      <div className="col-md-6">
        <SortableListOptionsZone />
      </div>

      <div className="col-md-6">
        <SortableListDroppableZone />
      </div>
    </div>
  );
};

export default SortableListDesktopInterface;
